@ -1,271 +1,275 @@
<script>
import { tikuManager, fileDataManage } from '@/observable'
import { postFileStorage } from '../../api/resource'
import { httpRequest } from '@/views/ResourceManagement/UploadEvent'

export default {
  name: 'ResourceFooter',
  components: {},
  props: {
    directoryValue: {
      type: String,
    },
    diskSpace: {
      type: Object,
      default: () => { }
    },
    isFolderOwner: {
      type: Boolean,
    },
    folderID: {
      type: Number,
    },
    textbookInfo: {
      type: Object,
    },
    directoryId: {
      type: Number,
    },
    fileType: {
      type: Number,
    },
    directoryChainPath: {
      type: Object,
    }
  },
  computed: {
    tikuActiveID() {
      return tikuManager.activeID
    },
    tikuManager() {
      return tikuManager
    },
    fileDataManage() {
      return fileDataManage
    },
    currentActiveIdObj() {
      return tikuManager.objIdData[tikuManager.activeID]
    },
    processNumber() {
      const total = this.diskSpace.total * (1024 ** 3)
      let process = (this.diskSpace.rest / total) || 0
      const num = Number(process) * 100
      return num
    }
  },
  mounted() {
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      /**
       * 关闭函数在生成器执行完成后会调用，本地选择资源上传后也会调用
       * 所以存在调用两次的情况，先后顺序会导致第一次id已经清空，第二次id读不到的问题
       * 所以 activeID 是 invalid 时，return 出去
       */
      if (!this.tikuActiveID) return
      this.currentActiveIdObj.resourceDialogShow = false
      this.tikuManager.activeID = '' // 清空当前激活的id
      this.fileDataManage.checkedList = [] // 插入完成后清空选中文件id
    },
    *getGen(arr) {
      const { richTextContentMultiple } = this.currentActiveIdObj
      for (const e of arr) {
        yield richTextContentMultiple(e)
      }
    },
    /**
     * @param {IteratorResult<any>} gVal 迭代器结果
     * @param {Generator<any>} gRun 生成器实例
     */
    gLoop(gVal, gRun) {
      const { done } = gVal
      if (done) {
        this.closeDialog()
        return
      }
      this.gLoop(gRun.next(), gRun)
    },
    insert() {
      if (this.tikuActiveID) {
        const { acceptFileType, urlData, insertFileListOnChange } = this.currentActiveIdObj
        // 如果传入了 insertFileListOnChange 回调函数，则不走富文本插入资源逻辑
        if (typeof insertFileListOnChange === 'function') {
          insertFileListOnChange(
            this.fileDataManage.fileArr.reduce((acc, cur) => {
              if (this.fileDataManage.checkedList.some(x => x.id === cur.id)) {
                acc = [...acc, {
                  ...cur,
                  ossUri: cur.path.url,
                  ossNode: cur.path.node,
                }]
              }
              return acc
            }, [])
          )
          this.closeDialog()
          return
        }
        /* 用于插入富文本的多个资源 */
        const insertArr = this.fileDataManage.fileArr.reduce((acc, cur) => {
          if (this.fileDataManage.checkedList.some(x => x.id === cur.id)) {
            acc = [
              ...acc,
              {
                fileType: acceptFileType,
                fileUrlData: urlData,
                response: {
                  node: cur.path.node,
                  uri: cur.path.url
                }
              }
            ]
          }
          return acc
        }, [])
        /* 递归调用 richTextContentMultiple 插入富文本 */
        const gRun = this.getGen(insertArr)
        this.gLoop(gRun.next(), gRun)
      }
    },
    /**
     * @params {bytes} 云空间占用大小（默认单位：字节）
     * @params {decimals} 保留两位小数
     */
    formatDataSize(bytes, decimals = 2) {
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['KB', 'MB', 'GB']
      if (bytes < k) return '0 KB'
      let i = Math.floor(Math.log(bytes) / Math.log(k)) - 1
      i = Math.min(i, sizes.length - 1)
      const value = bytes / Math.pow(k, i + 1)
      return `${parseFloat(value.toFixed(dm))} ${sizes[i]}`
    },
    importFile(cb, { accept }) {
      if (!cb) {
        throw Error('receive a callback function containing one parameter')
      }
      if (Object.prototype.toString.call(cb) !== '[object Function]') {
        throw Error('variable mast be a Function')
      }
      function inputChange() {
        const files = this?.files
        if (!files.length) {
          throw Error('a error in inputChange function, please checked')
        }
        cb(files)
      }
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = accept
      input.onchange = inputChange
      input.multiple = true
      document.body.appendChild(input)
      input.click()
      document.body.removeChild(input)
    },
    /**
     * 本地选取文件
     */
    async localUpload() {
      if (!this.directoryChainPath?.chainIdPath?.length) {
        this.$message.warning('如需插入资源，请先点击左下方按钮关联对应的课件目录后再插入资源')
        this.$emit('tipsAnimation')
        return
      }
      if (this.directoryValue === 'all') {
        this.$message.warning('请切换到对应目录再上传资源')
        return
      }
      const { insertFileListOnChange, beforeUpload, uploadAcceptFileType } = this.currentActiveIdObj
      this.importFile(
        async (fList) => {
          const fileList = [...fList]
          if (typeof beforeUpload === 'function') {
            // 选中所有文件待校验的promise
            const waitForHandlePromises = fileList.map(f => beforeUpload(f))
            const allHandle = await Promise.allSettled(waitForHandlePromises)
            const isRejected = allHandle.some(x => x.status === "rejected")
            // 存在一个校验失败就直接return，不进行任何上传逻辑处理
            if (isRejected) return
          }
          // 所有待执行上传的promise
          const allUploadPromises = fileList.map((file) => {
            return new Promise((resolve, reject) => {
              // 文件推送到 oss
              httpRequest(file, this.$api3.question_set.upload)
                .then(async (ossRes) => {
                  const { uri, node } = ossRes
                  /* 用于调用素材库插入的数据 */
                  const params = {
                    dict_id: this.directoryId, // 文件夹属于教材的某个目录的id
                    dict_ids: this.directoryChainPath.chainIdPath,
                    file_type: this.fileType,
                    folder_id: this.folderID,
                    is_folder: false,
                    is_public: this.$route.query.scope_type, // 身份标签 - 平台
                    origin_filename: file.name.split('.')[0], // 文件名称
                    path: node,
                    publisher_id: this.textbookInfo.publisher_id, // 出版社 id
                    subject_id: this.$route.query.subjectId // 音乐（1）或者美术（2）
                  }
                  const saveMaterialLibraryRes = await postFileStorage(params)
                  console.log('saveMaterialLibraryRes', saveMaterialLibraryRes)
                  insertFileListOnChange?.([{ ...file, ossUri: uri, ossNode: node }])
                  resolve('success')
                })
                .catch((err) => {
                  this.$message.error(err?.data?.error_msg || err)
                  reject()
                })
            })
          })
          // 执行所有上传
          const allUpload = await Promise.allSettled(allUploadPromises)
          // 是否所有文件都上传成功
          const isAllSuccessUpload = allUpload.every(x => x.status === 'fulfilled')
          // 如果设置了 inTimeClose 不管上传失败还是成功都关闭弹窗
          if (this.tikuManager.objIdData[this.tikuManager.activeID].inTimeClose) this.closeDialog()
          if (isAllSuccessUpload) this.$emit('refreshFolder')
        }, { accept: uploadAcceptFileType }
      )

    },
  }
}
</script>

<template>
  <div class="resourceFooterBox">
    <div class="path">当前章节<span>{{ directoryChainPath.chainName }}</span></div>
    <div class="btnBox">
      <el-button style="width: 120px; font-size: 16px; margin-right: 20px;" size="small" plain
        @click="localUpload" :disabled="!isFolderOwner">本地选取</el-button>
      <div>
        <el-button style="width: 120px; font-size: 16px;" size="small" type="primary"
          :disabled="fileDataManage.checkedList.length === 0" @click="insert">插入
        </el-button>
      </div>
    </div>
    <!-- <div _flex="1" v-if="$store.state.user.userInfo.type === $api.account.types.TEACHER.value">
			<div _w="200px">
				<el-progress :percentage="processNumber" _h="20px" :stroke-width="12" :show-text="false"></el-progress>
				<div _text="12px bolder [#000000]">
					{{ `云空间：${formatDataSize(diskSpace?.rest)} / ${diskSpace?.total}${diskSpace?.unit}` }}
				</div>
			</div>
		</div> -->
    <!--			<div class="textBox">-->
    <!--				<div class="t" @click="logtest">当前章节</div>-->
    <!--				<div class="ctx">-->
    <!--					广东教育出版社花城出版社/六艺·乐（音乐测试集合）一年级（勿删）/第一单元 何为乐艺-->
    <!--				</div>-->
    <!--			</div>-->
  </div>
</template>

<style scoped lang="scss">
.resourceFooterBox {
  border-top: 1px dashed #ccc;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .btnBox {
    display: flex;
    justify-content: space-around;
  }

  .path {
    color: #A6A6A6;
    font-size: 16px;

    span {
      color: #444444;
      margin-left: 20px;
    }
  }
}

.textBox {
  display: flex;
  flex-direction: row;
  flex: 1;

  .t {
    color: #afafaf;
    margin-right: 20px;
    font-size: 20px;
  }
}

:deep(.form-item-upload) {
  width: auto;
}
</style>
